import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup, FileViewerModal } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Space, Row, Col, Form, Input , Button, Popconfirm, message } from 'antd';
import { DownloadOutlined, SearchOutlined } from '@ant-design/icons';
import { DatePicker } from 'components/atoms'
import {  usePaymentDetail } from 'hooks';
import moment, { Moment } from 'moment';
import { dateFormat } from 'utils/date-utils';
import { isFileViewer } from 'utils/file-utils';
import { endpoints } from 'services';
import { SERVER_URL } from 'commons/constants';
import axios from 'axios';
import { usePopupManager } from 'react-popup-manager';
import { IMaskInput } from "react-imask";
import useStore from 'store';
import CheckInputModal from 'components/molecules/CheckInputModal';

export interface PaymentModalProps extends PopupProps {
    id: number;
}

const PaymentModal = ({ isOpen, onClose, id }: PaymentModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */  
  const [isCheckInput, setIsCheckInput] = useState<boolean>(false);
  const [dropMemo, setDropMemo] = useState<string>('');  

   /* ======================================================
   * variables
   * ====================================================== */
   const [form] = Form.useForm();
   const { TextArea } = Input;
   const { open } = usePopupManager(); 
   const auth = useStore((state) => state.auth);  

   /* ======================================================
   * events
   * ====================================================== */
   
  const onCloseCancle = () => {
    onClose?.(false); 
  }  

  const onDropMemoClose = (isOk, memo?) => {
    if (isOk) {
      const data = {
        id: id,
        status_type: 'drop',
        memo: form.getFieldValue("memo"),
        drop_memo: memo,
        payment_price: form.getFieldValue("payment_price").toString().replaceAll(',',''), 
        payment_day: form.getFieldValue("payment_day") ? dateFormat(form.getFieldValue("payment_day"), 'YYYY-MM-DD'):'null',
      }
      paymentConfirm(data)    
    } 
    setIsCheckInput(false);
  }

  const onUpdateState = (status: string) => {
    if (status === 'drop') {
      setDropMemo('');
      setIsCheckInput(true);
    } else {    
      const data = {
        id: id,
        status_type: status,
        memo: form.getFieldValue("memo"),
        payment_price: form.getFieldValue("payment_price").toString().replaceAll(',',''), 
        payment_day: form.getFieldValue("payment_day") ? dateFormat(form.getFieldValue("payment_day"), 'YYYY-MM-DD'):'null',
      }
      paymentConfirm(data) 
    }
  }

  const onUpdate = () => {
    const data = {
      id: id,
      memo: form.getFieldValue("memo"),
      payment_price: form.getFieldValue("payment_price").toString().replaceAll(',',''), 
      payment_day: form.getFieldValue("payment_day") ? dateFormat(form.getFieldValue("payment_day"), 'YYYY-MM-DD'):'null',
    }
    paymentUpdate(data) 
  }

  const onDownload = (fileSeq:number, fileName: string): void => {

    axios({
      url: SERVER_URL + endpoints.file.download + '?file_id=' + fileSeq,
      method: 'get',
      responseType: 'blob',
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
      })
      .catch(() => {
        message.error('파일 다운로드 중 에러가 발생했습니다.', 1);
      });
    };

    const onOpenFileViewer = (fileId: number, fileName: string) => {
      open(FileViewerModal, {
        fileid: fileId,
        filename: fileName,
        seq: 0,
        gubun: '',
        editable: false,
        onClose: (isOk) => {
          if (isOk) {
            
          };
        },
      }); 
     }    
  /* ======================================================
   * hooks
   * ====================================================== */
  const { payment, paymentUpdate, paymentConfirm, updateSuccess, confirmSuccess } = usePaymentDetail(id);   

  /* ======================================================
   * effects
   * ====================================================== */

  useEffect(() => {
    if (!!payment) {
      form.setFieldsValue({
        payment_price: payment.payment_price,
        payment_day: (!!payment.payment_day && payment.payment_day !== '0000-00-00') ? moment(payment.payment_day, "YYYY-MM-DD") : undefined,
        memo: payment.memo,
      });     
    }     
  }, [payment])

  useEffect(() => {
    if (updateSuccess || confirmSuccess)
    onClose?.(true);     
  }, [updateSuccess, confirmSuccess])  

    return (
      <>
        <ModalWrapper open={isOpen} onCancel={onCloseCancle} width={650} title={'강사료 지급 요청서'} closable>
            <Space direction="vertical" style={{ width: '100%' }}>
            <Form
                    form={form}
                    name="RefCode"
                    layout="horizontal"  
                    labelCol={{ flex: '100px' }}
                    style={{width:'100%'}}
                >                                        
                    <Form.Item label={'강사명'}>
                        <label>[{payment?.lecturer_type}] {payment?.lecturer_name}</label>                  
                    </Form.Item>   
                    <Row>
                      <Col span={12}>
                          <Form.Item label={'시간당 단가'} >
                          {payment?.lecturer_price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                          </Form.Item>  
                      </Col> 
                      <Col span={12}> 
                          <Form.Item label={'소득형태'}>
                          {payment?.lecturer_income_type}  
                          </Form.Item>   
                      </Col>            
                  </Row> 
                    <Form.Item label={'강사메모'}>
                        <pre style={{display: "inline"}}>{payment?.lecturer_memo} </pre>                  
                    </Form.Item>
                    <Form.Item label={'통장사본'}>
                    {(!!payment && !!payment.account_number_file_id && payment.account_number_file_id > 0 && !!payment.account_number_file_name) && (
                            <Space key={payment.account_number_file_id}>
                                <Button onClick={()=>{onDownload(payment.account_number_file_id||0, payment.account_number_file_name||'')}} shape="round" icon={<DownloadOutlined />} size='small' style={{padding:'0px 3px'}}/>
                                {isFileViewer(payment.account_number_file_name) && (<Button onClick={()=>{onOpenFileViewer(payment.account_number_file_id||0, payment.account_number_file_name||'')}} shape="round" icon={<SearchOutlined />} size='small' style={{padding:'0px 3px'}}/>)}                                   
                                {payment.account_number_file_name}
                            </Space>
                        )}                       
                    </Form.Item>                       
                    <Form.Item label={'발행서류'}>
                    </Form.Item>   
                    <Form.Item label={'프로젝트'}>
                        <label>{payment?.project_title}  </label>
                    </Form.Item>                       
                    <Form.Item label={'강의주제'}>
                        <label>{payment?.lecture_subject}  </label>
                    </Form.Item> 
                    <Row>
                      <Col span={12}>
                          <Form.Item label={'교육일'} >
                          {payment?.start_date}
                          </Form.Item>  
                      </Col> 
                      <Col span={12}> 
                          <Form.Item label={'교육시간'}>
                          {payment?.time_count}  
                          </Form.Item>   
                      </Col>            
                  </Row>   
                  <Row>
                      <Col span={12}>
                          <Form.Item label={'고객사'} >
                          {payment?.company_name}
                          </Form.Item>  
                      </Col> 
                      <Col span={12}> 
                          <Form.Item label={'요청자'}>
                          {payment?.created}  
                          </Form.Item>   
                      </Col>            
                  </Row>                                      
                    <Form.Item name="payment_price" label={'지급금액'}>
                    <IMaskInput 
                      min={0} 
                      mask = {Number}
                      thousandsSeparator={','}
                      className={'ant-input'} 
                      unmask={'typed'} 
                      onAccept = {((value, mask) => form.setFieldValue('payment_price', value))}/>    
                    </Form.Item>                     
                    <Form.Item name="payment_day" label={'지급일'}>
                      <DatePicker showTime={false} format="YYYY-MM-DD" disabled={!(auth.login?.div?.split(',').some(item => ['102', '999'].includes(item)))}/>      
                    </Form.Item>    
                    <Form.Item name='memo' label={'메모'}>
                        <TextArea rows={2} placeholder='메모를 입력하세요'/>   
                    </Form.Item> 
                    {(payment?.status_type === 'drop') && (
                    <Form.Item label={'반려사유'}>
                        <label>{payment?.drop_memo}</label>
                    </Form.Item>                         
                    )}                                                                                  
                </Form> 
                {payment?.status_type !== 'drop' && (
                <ButtonGroup className={'buttonsWrapper'}>
                <Button onClick={()=>{onClose?.(false)}}>닫기</Button>
                <Space>
                {(payment?.status_type === 'confirm')? (
                    (auth.login?.div?.split(',').some(item => ['102', '999'].includes(item))) && (
                      <Popconfirm
                          title="결재가 승인된 항목입니다. 반려 하시겠습니까?"
                          okText="반려"
                          cancelText="취소"
                          onConfirm={() => { onUpdateState('drop')}}
                      >   
                          <Button danger>반려</Button>
                      </Popconfirm>
                    )
                  ): (payment?.status_type === 're-request') ? (
                    <>
                      <Button onClick={onUpdate}>저장</Button>
                      <Popconfirm
                          title="결재를 다시 발행 하시겠습니까?"
                          okText="재발행"
                          cancelText="취소"
                          onConfirm={() => { onUpdateState('request') }}
                      >   
                          <Button type="primary">재발행</Button>
                      </Popconfirm>                     
                    </>
                  ) : (
                    (auth.login?.div?.split(',').some(item => ['102', '999'].includes(item))) && (
                      <>
                        <Popconfirm
                            title="결재 요청을 재요청 하시겠습니까?"
                            okText="재요청"
                            cancelText="취소"
                            onConfirm={() => {onUpdateState('re-request')}}
                        >   
                            <Button>재요청</Button>
                        </Popconfirm> 
                        <Button onClick={onUpdate}>저장</Button>
                        <Popconfirm
                            title="결재 요청을 반려 하시겠습니까?"
                            okText="반려"
                            cancelText="취소"
                            onConfirm={() => {onUpdateState('drop')}}
                        >   
                            <Button danger>반려</Button>
                        </Popconfirm>                          
                        <Popconfirm
                            title="결재 요청을 승인 하시겠습니까?"
                            okText="승인"
                            cancelText="취소"
                            onConfirm={() => { onUpdateState('confirm') }}
                        >   
                            <Button type="primary">승인</Button>
                        </Popconfirm>                   
                      </>                      
                    )
                  )}
                </Space>
                
            </ButtonGroup>  
                )}

          </Space>  
        </ModalWrapper>  
        <CheckInputModal
          title="반려 사유 입력"
          memo={dropMemo}
          visible={isCheckInput}
          onOk={onDropMemoClose}
          onCancel={onDropMemoClose}
        />         
      </>
    )    
};

export default React.memo(PaymentModal);    